import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    agudezasVisuales: [],
  },

  getters: {
    getAgudezasVisuales: (state) => state.agudezasVisuales,
  },

  mutations: {
    SET_AGUDEZAS_VISUALES(state, agudezasVisuales) {
      state.agudezasVisuales = agudezasVisuales;
    },
  },

  actions: {
    async fetchAgudezasVisuales({ commit }, idHistoriaClinica) {
      await axios
        .get(`PoliciaCuadrantes/C3/historiasclinicas/${idHistoriaClinica}/agudezasvisuales`)
        .then((response) => {
          commit('SET_AGUDEZAS_VISUALES', response.data.data);
        });
    },

    async saveAgudezasVisuales(context, agudezasVisuales) {
      const { idHistoriaClinica } = context.rootState.historiaClinica;
      await axios
        .post(`PoliciaCuadrantes/C3/historiasclinicas/${idHistoriaClinica}/agudezasvisuales`, agudezasVisuales);
    },

    async updateAgudezasVisuales(_, agudezasVisuales) {
      await axios
        .put(
          `PoliciaCuadrantes/C3/historiaclinica/${
            agudezasVisuales.fk_idHistoriaClinica
          }/agudezasVisuales/${
            agudezasVisuales.fk_idAgudezasVisuales}`,
          agudezasVisuales,
        );
    },
  },
};
